import api from "@/libs/api";

const initState = {
  fromDashboard: false,
  // fromBookmark: false,
  dashboardTitle: JSON.parse(localStorage.getItem('dashboardTitle')) || {},
  markList: [],
  dashList: JSON.parse(localStorage.getItem('dashList')) || [],
  markData: {},
  dashboardItems: [], //概览条目
  dashboardItemIndex: [], //概览条目顺序
  bookmarkReq: {}
};

const dashboards = {
  state: initState,
  mutations: {
    RESET_dashboards(state) {
      state = Object.assign(state, initState);
    },
    SET_DASHBOARD_TITLE(state, title) {
      state.dashboardTitle = title;
      localStorage.setItem('dashboardTitle', JSON.stringify(title))
    },
    SET_DASHBOARD_TITLES(state, title) {
      state.dashboardTitle.name = title;
      localStorage.setItem('dashboardTitle', JSON.stringify(state.dashboardTitle))
    },
    SET_MARK_LIST(state, list) {
      state.markList = list;
    },
    SET_DASH_LIST(state, list) {
      state.dashList = list;
      localStorage.setItem('dashList', JSON.stringify(list))
    },
    SET_FROM_DASHBOARD(state, value) {
      state.fromDashboard = value;
    },
    SET_MARK_DATA(state, data) {
      state.markData = data;
    },
    SET_DASH_ITEMS(state, list) {
      state.dashboardItems = list;
    },
    SET_DASH_ITEM_INDEX(state, indexList) {
      state.dashboardItemIndex = indexList;
    }
    /*SET_DASH_ITEM_CHART(state, data) {
      state.dashItemChart = data;
    },*/
    /*SET_FROM_MARK(state, bool) {
      state.fromBookmark = bool;
    }*/
  },
  getters: {},
  actions: {
    setDashList({ commit }, projectId) {
      //4.3   获取数据概览
      api.getDashboards(projectId).then(res => {
        commit("SET_DASH_LIST", res.data.fields.dashboards);
      });
    },
    //3.2   获取书签
    setMarkList({ commit }, projectId) {
      api.getBookmarks(projectId).then(res => {
        commit("SET_MARK_LIST", res.data.fields.list);
      });
    }
  }
};

export default dashboards;



// WEBPACK FOOTER //
// ./src/store/modules/dashboards.js